import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { InventoryCategoryService } from '../../services/inventory-category.service';
import { InventoryCategory } from '@contracts/interfaces/inventory-category';
import { ConnectionService } from 'src/app/services/connection.service';
import { MediaService } from 'src/app/services/media.service';
import { InventoryService } from 'src/app/services/inventory.service';
import { Router } from '@angular/router';

export interface DialogData {

}

@Component({
  selector: 'app-inventory-categories-dialog',
  templateUrl: 'inventory-categories.dialog.html',
  styleUrls: ['./inventory-categories.dialog.scss']
})
export class inventoryCategoriesDialogComponent {

  public loading = true;

  public searchQuery: string = null;
  public categorys: InventoryCategory[] = [];
  public trackThumbChanges: number[] = [];
  
  private categoryStats: any[] = [];


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<inventoryCategoriesDialogComponent>,
    public inventoryCategoryService: InventoryCategoryService,
    private inventoryService: InventoryService,
    private connectionService: ConnectionService,
    private mediaService: MediaService,
    private cdr: ChangeDetectorRef,
    private router: Router
    ) {

    }

  ngOnInit() {
    this.load();
  }

  load() {
    this.loading = true;

    this.inventoryService.getInventoryListCompiled().subscribe((result: any) => {
      this.categorys = result.filter(category => category.id != null);
      this.loading = false;
    });

    this.inventoryService.getInventoryStats().subscribe((r:any) => {
      this.categoryStats = r;
      this.cdr.detectChanges();
    });
  }

  getCategoryPlaceholder() {
    return `background-image: url('${this.connectionService.address}/inventory-category-pictures/placeholder.jpg');`;
  }

  getThumbImage(category: InventoryCategory, index: number) {
    let hasUpdated = "";
    if (this.trackThumbChanges[index] != undefined) {
      hasUpdated = "?t=" + this.trackThumbChanges;
    }

    return this.connectionService.address + "/inventory-category-pictures/" + category.id + "-dp.jpg" + hasUpdated;
  }
  
  getStats(category: InventoryCategory) {
    if (this.categoryStats.length > 0) {
      for (let c of this.categoryStats) {
        if (c.id == category.id) {
          return c;
        }
      }
    }

    return {
      needsAttention: 0,
      unlisted: 0
    }
  }

  newCategory() {
    this.inventoryCategoryService.newCategoryDialog((r) => {
      this.load();
    });
  }

  selectCategory(category: InventoryCategory) {
    this.router.navigate(['/inventory/c', category.id]);
    this.close();
  }

  close() {
    this.dialogRef.close();
  }

}
